"use client";


import { renderToString } from "react-dom/server";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useResponsive } from "@/client/hooks/useResponsive";
import { useState, lazy } from "react";
import classNames from "classnames";
import { Body, Heading } from "@/client/foundations/Typography";
import { Icons } from "@/components/Icons";
// import { ModalDirection } from "@/components/Modal/Modal";
import { Box, Stack } from "@/layouts/LayoutComponents";
import dynamic from "next/dynamic";
// import ImageWrapper from "@/components/ImageWrapper";
// import Model from "@/components/Modal/Modal";

enum ModalDirection {
  BottomUp = "bottomup",
  RightLeft = "rightleft",
  TopDown = "topdown",
}

const Model = dynamic(() => import("@/components/Modal/Modal"));
const Card = dynamic(() => import('@/blocks/Cards/Card/Card'), { ssr: false });	

const ImageWrapper = lazy(()=> import("@/components/ImageWrapper"));

export default function ImageCardOverlay(props: any) {
  const { title, subtitle, description, image, overlay1, overlay2, overlay3, animated, animationType, btn1_label = "Show details", btn1_icon = Icons?.Plus, btn1_iconPosition = "after", btn1_variant = "ghost", btn1_size = "s", btn1_action = () => { } } = props;
  const { isSm, isMd } = useResponsive();

  const [showDetails, setShowDetails] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const desktopSources: string[] = [];
  const mobileSources: string[] = [];

  if (overlay1) {
    desktopSources.push((overlay1 ? overlay1 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
    mobileSources.push((overlay1 ? overlay1 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
  }
  if (overlay2) {
    desktopSources.push((overlay2 ? overlay2 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
    mobileSources.push((overlay2 ? overlay2 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
  }
  if (overlay3) {
    desktopSources.push((overlay3 ? overlay3 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
    mobileSources.push((overlay3 ? overlay3 : "https://placehold.co/1030x570/red/white") + "?fit=fill&f=center");
  }

  const overlayImages = isMd ? desktopSources : mobileSources;

  const placeholderImage = {
    width: 500,
    height: 300,
    src: image ? (image + "?fit=fill&f=center") : 'https://placehold.co/300',
  };

  return (
    <>
      <Card title={title} subtitle={subtitle}
        mediaWidth={props?.imageWidth || "30px"}
        mediaHeight={props?.imageHeight || "30px"}
        mediaWrapperWidth={props?.imageWrapperWidth || '56px'}
        mediaWrapperHeight={props?.imageWrapperHeight || '56px'}
        description={description && renderToString(documentToReactComponents(description))}
        btn1_label={btn1_label} btn1_icon={btn1_icon} btn1_iconPosition={btn1_iconPosition} btn1_variant={btn1_variant} btn1_size={btn1_size}
        image={placeholderImage} animated={animated} animation={animationType} className="overflow-hidden rounded-image-overlay bg-interactive-image-overlay" btn1_action={() => {
          setShowDetails(true);
        }}></Card >
      <Model
        id="location-modal"
        direction={ModalDirection.BottomUp}
        open={showDetails}
        onClose={() => setShowDetails(false)}
        maxWidth={props?.maxWidth}
        customHeader={
          <Box
            className={classNames("justify-between flex-row", {
              "!flex-row-reverse": !isMd,
            })}
            vAlignContent="center"
          >
            {isMd && (
              <Heading size="l" data-test-id={props["data-test-id"] + "-title"}>
                {title}
              </Heading>
            )}
            <Icons.Close
              id="close-icon"
              size="m"
              className="hover:cursor-pointer"
              onClick={() => setShowDetails(false)}
            />
          </Box>
        }
        footerElement={
          <Box className="justify-between" vAlignContent="center">
            <Icons.ArrowLeft
              id="arrow-left-icon"
              size="l"
              className="hover:cursor-pointer"
              onClick={() => setActiveIndex(activeIndex === 0 ? overlayImages?.length! - 1 : activeIndex - 1)}
            />
            {isMd && (
              <Body size="m" data-test-id={props["data-test-id"] + "-description"}
                className="relative text-center">
                {description}
              </Body>
            )}
            <Icons.ArrowRight
              id="arrow-right-icon"
              size="l"
              className="hover:cursor-pointer"
              onClick={() => setActiveIndex(activeIndex === overlayImages?.length! - 1 ? 0 : activeIndex + 1)}
            />
          </Box>
        }
      >
        <Stack fluid column className="relative w-full h-full !overflow-x-hidden" hAlignContent="center">
          {!isMd && (
            <Heading size="l" data-test-id={props["data-test-id"] + "-title"} className="text-center">
              {title}
            </Heading>
          )}
          <Box className="relative" width={isSm ? 1030 : 412} height={isSm ? 570 : 345}>
            {overlayImages?.map((item, index) => (
              <ImageWrapper
                key={index}
                data-test-id={props["data-test-id"] + "-image"}
                alt={props["data-test-id"] + "-image"}
                src={item}
                placeholder="blur"
                blurDataURL={item}
                width={isSm ? 1030 : 412}
                height={isSm ? 570 : 345}
                loader={({ src }) => src}
                className={classNames("absolute transition-opacity duration-500", {
                  "opacity-100": index === activeIndex,
                  "opacity-0": index !== activeIndex,
                })}
              // loading="lazy"
              />
            ))}
          </Box>
          {!isMd && (
            <Body size="m" data-test-id={props["data-test-id"] + "-description"}
              className="relative text-center">
              {description}
            </Body>
          )}
        </Stack>
      </Model>
    </>
  );
}